import React, { useState } from 'react';
import { Link2, Check } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useStore } from '../../hooks/useStore';
import { useToast } from '../../contexts/ToastContext';
import Button from '../common/Button';

// Monta URL `<storefront>/produto/:idOrSlug?ref=<userId>` do reseller atual
// e copia pro clipboard. Usado em ResellerCatalog e ResellerDashboard.
function buildShareUrl({ store, product, resellerId }) {
  const slug = store?.slug;
  const domain = store?.customDomain && store?.customDomainVerified ? `https://${store.customDomain}` : '';
  const productPath = `/produto/${product.slug || product.id}`;
  const base = domain
    ? `${domain}${productPath}`
    : slug
    ? `${window.location.origin}/fornecedor/${slug}${productPath}`
    : `${window.location.origin}${productPath}`;
  return `${base}?ref=${resellerId}`;
}

const ShareLinkButton = ({ product, size = 'sm', variant = 'subtle', fullWidth = false }) => {
  const { user, currentStore } = useAuth();
  const { store: publicStore } = useStore();
  const { success, info } = useToast();
  const [copied, setCopied] = useState(false);

  const store = publicStore || currentStore;
  if (!user?.id || !product) return null;

  const handleCopy = async () => {
    const url = buildShareUrl({ store, product, resellerId: user.id });
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      success('Link copiado!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      info('Copie manualmente: ' + url, 8000);
    }
  };

  return (
    <Button
      size={size}
      variant={variant}
      fullWidth={fullWidth}
      onClick={handleCopy}
      leftIcon={copied ? <Check size={14} /> : <Link2 size={14} />}
    >
      {copied ? 'Copiado' : 'Compartilhar'}
    </Button>
  );
};

export default ShareLinkButton;
